<template>
  <svg 
    v-bind="$attrs"
    :width="width"
    :height="height"
    viewBox="0 0 37 29" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.1875 28.6792C16.1875 28.6792 13.875 28.6792 13.875 26.3635C13.875 24.0477 16.1875 17.1006 25.4375 17.1006C34.6875 17.1006 37 24.0477 37 26.3635C37 28.6792 34.6875 28.6792 34.6875 28.6792H16.1875ZM25.4375 14.7849C27.2774 14.7849 29.042 14.053 30.3431 12.7501C31.6441 11.4473 32.375 9.68025 32.375 7.83776C32.375 5.99527 31.6441 4.22823 30.3431 2.92539C29.042 1.62255 27.2774 0.890625 25.4375 0.890625C23.5976 0.890625 21.833 1.62255 20.5319 2.92539C19.2309 4.22823 18.5 5.99527 18.5 7.83776C18.5 9.68025 19.2309 11.4473 20.5319 12.7501C21.833 14.053 23.5976 14.7849 25.4375 14.7849Z"
      :fill="fill"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.062 28.6831C11.7192 27.9602 11.5482 27.1675 11.5625 26.3674C11.5625 23.2296 13.135 19.9991 16.0395 17.7529C14.5898 17.3056 13.0794 17.0868 11.5625 17.1045C2.3125 17.1045 0 24.0517 0 26.3674C0 28.6831 2.3125 28.6831 2.3125 28.6831H12.062Z"
      :fill="fill"
    />
    <path
      d="M10.4062 14.7836C11.9395 14.7836 13.41 14.1737 14.4942 13.088C15.5784 12.0023 16.1875 10.5298 16.1875 8.99435C16.1875 7.45894 15.5784 5.98642 14.4942 4.90072C13.41 3.81502 11.9395 3.20508 10.4062 3.20508C8.87296 3.20508 7.40248 3.81502 6.31828 4.90072C5.23409 5.98642 4.62499 7.45894 4.62499 8.99435C4.62499 10.5298 5.23409 12.0023 6.31828 13.088C7.40248 14.1737 8.87296 14.7836 10.4062 14.7836Z"
      :fill="fill"
    />
  </svg>

</template>

<script lang="ts" setup>
const props = defineProps({
  width: {
    type: [String, Number],
    default: 37,
  },
  height: {
    type: [String, Number],
    default: 29,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
});
</script>
